import styled from "styled-components";

export const BlogHeading = styled.p`
  font-size: 2rem;
  font-weight: bold;
  margin: 1.5rem 0rem;
  @media (min-width: 990px) {
    font-size: 2.2rem;
  } ;
`;

export const BlogSubHeading = styled.h3`
  font-size: 1.5rem;
  color: #3a3b3c;
  font-weight: bold;
  margin: 1.5rem 0rem;

  @media (min-width: 990px) {
    font-size: 1.6rem;
  } ;
`;

export const BlogSubHeadingSmall = styled.h5`
  font-size: 1.4rem;
  font-weight: bold;
  margin: 1.5rem 0rem;
`;

export const BlogImage = styled.img`
  width: 100%;
  margin: 1.5rem 0rem;
`;

export const BlogList = styled.ul`
  padding: 0.5rem 3rem;
  @media (max-width: 992px) {
    padding: 0.5rem 2rem;
  } ;
`;

export const BlogHighlight = styled.span`
  padding: 0.1rem 0.2rem;
  background-color: #f4f406;
`;

export const BlogLi = styled.li`
  margin: 1rem 0rem;
  font-size: 1.1rem;
  @media (min-width: 990px) {
    font-size: 1.3rem;
  } ;
`;

export const BlogText = styled.p`
  margin: 1.5rem 0rem;
  text-align: justify;
  font-size: 1.1rem;
  @media (min-width: 990px) {
    font-size: 1.3rem;
  } ;
`;

export const BlogWrapper = styled.div`
  line-height: 1.5;
  @media (min-width: 990px) {
    padding: 0rem 5rem;
  } ;
`;
